import Amex from 'Components/icons/Amex';
import AtAndT from 'Components/icons/At&t';
import MasterCard from 'Components/icons/MasterCard';
import Oxxo from 'Components/icons/Oxxo';
import PayPal from 'Components/icons/PayPal';
import Visa from 'Components/icons/Visa';

export const icons = [
  { id: 1, component: <Amex /> },
  { id: 2, component: <AtAndT /> },
  { id: 3, component: <MasterCard /> },
  { id: 4, component: <Oxxo /> },
  { id: 5, component: <PayPal /> },
  { id: 6, component: <Visa /> },
];
